import { AuthFetchWithResponse } from 'src/Types/api'
import { StatusCodes } from '@e3dc-react/shell/Libs'
import { ApiResult } from 'src/Libs/api'
import { handleFetchError } from 'src/Libs/api/utils'
import accountLinksToModelTransformer from 'src/Libs/installation-rights-management/transformer/account-links-to-model.transformer'
import { AccountLinkModel } from 'src/Libs/installation-rights-management/models'
import { AccountLinkListDto } from 'src/Libs/installation-rights-management/dto'

/**
 * Fetch the account links with company type by installation id
 * @param installationId - installation id
 * @param authFetch
 * @returns - Account links array
 */
export const fetchAccountLinksWithCompanyType = async (
  authFetch: AuthFetchWithResponse,
  installationId?: string
): Promise<ApiResult<AccountLinkModel[]>> => {
  if (!installationId) return new ApiResult<AccountLinkModel[]>(null, true, new Error('Installation id is required'))

  try {
    const response = await authFetch<AccountLinkListDto>({
      path: `installations/${installationId}/account-links`,
      endpoint: process.env.REACT_APP_INSTALLATIONS_ENDPOINT,
      payload: {
        filterOr: 'accountType=company',
      },
    })
    if (response.status === StatusCodes.OK) {
      const data = accountLinksToModelTransformer(response.data)
      return new ApiResult<AccountLinkModel[]>(data)
    }

    return new ApiResult<AccountLinkModel[]>(null, true)
  } catch (error) {
    return handleFetchError<AccountLinkModel[]>(error)
  }
}
